import { DiscountBadgeIcon, DoubleLeftIcon } from 'assets/icons';
import classes from './BlackFridaySpecialDiscount.module.scss';
import clsx from 'clsx';

function BlackFridaySpecialDiscount() {
  return (
    <a
      href='https://campaign.iranserver.com/bon-baroon?utm_source=raychat&utm_medium=siteredirect'
      target='_blank'
      rel='noreferrer'
      className={clsx(
        classes.black_friday_special_discount_wrapper,
        'user-select-none'
      )}
    >
      <div className={classes.right_part}>
        <img src={DiscountBadgeIcon} alt='Discount Badge Icon' />

        <span className={classes.text}>تخفیف ویژه بلک فرایدی</span>
      </div>

      <img
        src={DoubleLeftIcon}
        alt='Double Left Icon'
        className={classes.double_left_icon}
      />
    </a>
  );
}

export default BlackFridaySpecialDiscount;
